import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "@/assets/style.scss";
import i18n from "./utils/i18n";
Vue.config.productionTip = false;
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { Loading } from "vant";
// import { linkMyWallet } from "@/contract";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import Web3Plugin from './plugins/web3'
import $utils from '@/utils/utils'
Vue.use(Loading);
Vue.use(Web3Plugin)
Vue.use(ElementUI);
Vue.prototype.$utils = $utils
// 简单配置
NProgress.inc(0.2);
NProgress.configure({
  easing: "ease",
  speed: 500,
  showSpinner: false,
});

router.beforeEach(async (to, from, next) => {
  NProgress.start();
  // if (!store.state.user.accountAddress) {
  //   let address = await linkMyWallet();
  //   if (address && address != "-1") {
  //     // store.dispatch("loadUserData");
  //   }
  // }
  next();
});

router.afterEach(() => {
  NProgress.done();
});
new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
